<template>
  <v-modal
    v-if="showModal"
    @close="closeModal"
  >
    <template #header>
      File Upload
    </template>
    <template v-if="file">
      <div
        v-if="fileConfirmed"
        class="row align-items-center"
      >
        <div class="col-lg-6">
          <v-fieldset
            v-show="isDescriptionRequired"
            v-model="uploadDescription"
            type="textarea"
            text="Details / Addressed Non-Conformances*"
            :is-required="isDescriptionRequired"
            @input="inputChange"
          />
        </div>
        <div 
          :class="{ 'col-lg-6': isDescriptionRequired, 'col-lg-12': !isDescriptionRequired }"
        >
          <v-fileupload
            v-if="file"
            :file-name="file.name"
            :file-size="file.size | formatFileSize"
            @clear="fileRemoved"
          />
        </div>
        <v-spinner
          v-if="isUploading"
          :is-full="false"
        />
      </div>
      <div
        v-else
        class="text--center"
      >
        <p class="text--lg">
          Are you sure this is the file you want to upload?
        </p>
        <p class="text--lg">
          <strong>{{ file.name }}</strong> {{ file.size | formatFileSize }}
        </p>
        <v-button-group is-inline>
          <v-button
            v-if="file"
            has-min-width
            @click="fileConfirmed = true"
          >
            Yes
          </v-button>
          <v-button
            color="secondary"
            has-min-width
            @click="fileRemoved"
          >
            No
          </v-button>
        </v-button-group>
      </div>
    </template>
    <v-dropzone
      v-else
      @file-added="fileAdded"
      @file-error="uploadError"
    />
    <template #footer>
      <v-button-group is-right>
        <v-button
          v-if="file && fileConfirmed"
          size="lg"
          has-min-width
          @click="uploadDocument"
        >
          Finish
        </v-button>
        <v-button
          color="secondary"
          size="lg"
          has-min-width
          @click="closeModal"
        >
          Cancel
        </v-button>
      </v-button-group>
    </template>
  </v-modal>
</template>

<script>
  import Button from "@/atoms/Button";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import Dropzone from "@/molecules/Dropzone";
  import Fieldset from "@/molecules/Fieldset";
  import FileUpload from '@/molecules/FileUpload'
  import Modal from "@/atoms/Modal";
  import Spinner from "@/atoms/Spinner";

  import { formatFileSize } from "../../common/formatting";

  import { mapState, mapActions } from 'vuex'

  export default {
    name: "UploadModal",
    components: {
      "v-button": Button,
      "v-button-group": ButtonGroup,
      "v-dropzone": Dropzone,
      "v-fieldset": Fieldset,
      "v-fileupload": FileUpload,
      "v-modal": Modal,
      'v-spinner': Spinner
    },
    filters: {
      formatFileSize: formatFileSize
    },
    props: {
      isDescriptionRequired: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        showModal: false,
        file: null,
        fileConfirmed: false,
        uploadDescription: "",
        isUploading: false,
      };
    },
    mounted() {
      this.$on('openModal', this.openModal)
    },
    computed: {
      ...mapState({
      })
    },
    methods:{
      ...mapActions([
      ]),
      openModal() {
        this.showModal = true;
      },
      closeModal() {
        this.file = null;
        this.showModal = false;
        this.fileConfirmed = false;
        this.uploadDescription = '';
        this.isUploading = false;
      },
      fileAdded(file) {
        this.file = file;
      },
      fileRemoved() {
        this.fileConfirmed = false;
        this.file = null;
      },
      inputChange(val) {
        this.uploadDescription = val;
      },
      uploadDocument: function () {
        this.isUploading = true;
        this.$emit('upload', this.file, this.fileDescription);
      },
      uploadError: function (errors) {
        for (var i = errors.length - 1; i >= 0; i--) {
          this.$notify({
            title: 'Error',
            text: errors[i],
            type: 'error'
          });
        }
      },
    },
    
  }
</script>
